// extracted by mini-css-extract-plugin
var _1 = "X9HFKLSUvm";
export { _1 as "root" }
